import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Input, VerticalSpacing } from '../components/Boneyard';

const Asterisk = styled.span`
  &:before {
    content: '*';
    color: red;
    font-size: 1.1em;
  }
`;

const Tooltip = styled.div`
  position: relative;
  display: inline-block;
  margin-left: 5px;
`;

const TooltipText = styled.span`
  display: none;
  width: 15em;
  background-color: ${props => props.theme.colors.common.peacockBlue};
  font-size: 15px;
  color: #fff;
  text-align: center;
  padding: 1em;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
  bottom: 100%;
`;

const Icon = styled.img`
  object-fit: contain;
`;

const InputField = ({
  label,
  required = false,
  tooltip = null,
  name,
  ...props
}) => {
  if (tooltip) {
    return (
      <>
        {label && (
          <label htmlFor={name}>
            {label}
            {required && <Asterisk />}
          </label>
        )}
        <Tooltip>
          <Icon src={tooltip.icon} alt="" />
          <TooltipText>{tooltip.text}</TooltipText>
        </Tooltip>
        <VerticalSpacing size={1} />
        <Input {...props} name={name} />
      </>
    );
  }
  return (
    <>
      {label && (
        <>
          <label htmlFor={name}>
            {label}
            {required && <Asterisk />}
          </label>
          <VerticalSpacing size={1} />
        </>
      )}
      <Input {...props} name={name} />
    </>
  );
};

InputField.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  tooltip: PropTypes.object,
  name: PropTypes.string.isRequired,
};

export default InputField;
